import { create } from 'zustand';
import { WfTyphoon } from '../models/WfTyphoon';

interface WfTyphoonStore {
  currentTyphoon: WfTyphoon | null;
  setCurrentTyphoon: (currentTyphoon: WfTyphoon | null) => void;
  isActive: () => boolean;
}

export const useWfTyphoonStore = create<WfTyphoonStore>((set, get) => ({
  currentTyphoon: null,
  setCurrentTyphoon: (currentTyphoon: WfTyphoon | null) => set({ currentTyphoon }),
  isActive: () => {
    const typhoon = get().currentTyphoon;
    if (!typhoon?.startDateTime || !typhoon?.stopDateTime) return true;

    const now = new Date();
    return now >= new Date(typhoon.startDateTime) && now <= new Date(typhoon.stopDateTime);
  },
}));
